import script from "./PrimaryBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryBtn.vue?vue&type=style&index=0&id=608d9585&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608d9585"]])

export default __exports__